<template>
  <div :class="fullscreen ? 'full-screen' : ''" class="empty-view">
    <img :src="require('@assets/ic_error_page.png')" alt="" />
    <div>
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: "页面加载失败"
    },
    fullscreen: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="less" scoped>
.empty-view {
  z-index: 1000;
  width: 100%;
  height: 100%;
  text-align: center;
  background: #efeff4;

  img {
    width: 50%;
    height: auto;
    margin-top: 50%;
  }
}
.full-screen {
  position: absolute;
}
</style>
